import type { NuxtAppConfig } from 'nuxt/schema';

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();

  const url = useRequestURL();
  const isPure =
    PURE_HOST.some(item => item.test(url.host)) || url.searchParams.get('pure') === '1';

  if (runtimeConfig.public.privatization || isPure) {
    return {};
  }

  // 移动端判断逻辑
  const { isMobile } = useDevice();
  if (isChinese()) {
    useHead({
      script: [
        {
          src: 'https://polyfill.youyan3d.com/polyfill.js?features=es2015,es2016,es2017,es2018,es2019,es2020,es2021,es2022,globalThis,es2023',
        },
        {
          src: 'https://ykf-webchat.7moor.com/javascripts/7moorInit.js?accessId=b5280620-7c49-11ee-80b7-ff4a5856c7b1&autoShow=false&language=ZHCN',
          async: true,
        },
      ],
    });

    return;
  } else {
    const headConfig = {
      script: [
        {
          src: 'https://polyfill.rendora.ai/polyfill.js?features=es2015,es2016,es2017,es2018,es2019,es2020,es2021,es2022,globalThis,es2023',
        },
        {
          // cookie 控制面板
          src: 'https://fe.rendora.ai/rendora/components/r-gdpr-cookie-consent/1.0.6/bundle.js',
          defer: true,
        },
        {
          innerHTML: `
; (function () {const s1 = document.createElement('script')
const s0 = document.getElementsByTagName('script')[0]
s1.async = true
s1.src = 'https://embed.tawk.to/6661c6b9981b6c5647799e6c/1hvmv0h4k'
s1.charset = 'UTF-8'
s1.setAttribute('crossorigin', '*')
s0.parentNode?.insertBefore(s1, s0)
})()`,
          async: true,
        },
        // <script src="https://analytics.ahrefs.com/analytics.js" data-key="F236zO7yBqsCByJixUWSKA" async></script>
        {
          src: 'https://analytics.ahrefs.com/analytics.js',
          'data-key': 'F236zO7yBqsCByJixUWSKA',
          async: true,
        },
        {
          src: 'https://www.googletagmanager.com/gtag/js?id=G-8WNSVY2PEK',
        },
        {
          innerHTML: `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-8WNSVY2PEK');`,
        },
      ],
    };

    if (!isMobile) {
      useHead(headConfig as NuxtAppConfig['head']);
    }
  }
});
